import comp from "./WorksheetCreateType";
export default comp;
